<template>
	<div class="page-dropship">
		<!-- Hero Section -->
		<div
			v-if="!isOoLoggedIn && isUserCan('dropship_add')"
			class="alert alert-danger"
			role="alert"
		>
			Belum ada akun penjualan yang terhubung. silahkan hubungkan akun penjualan
			anda terlebih dahulu!
			<router-link
				class="btn btn-primary"
				:class="{ 'is-loading': isLoading }"
				to="/settings/connections?redirect=/products/dropship"
			>
				+ Hubungkan
			</router-link>
		</div>
		<div class="dropship-store-hero pt-4">
			<div class="container mt-3">
				<div class="row">
					<div class="col-md-12">
						<div class="dropship-store-hero__header mb-5">
							<h4 class="heading--4">Product Dropship</h4>
						</div>
						<div class="col-md-8 offset-md-2">
							<div class="dropship-search-form">
								<form @submit.prevent="applySearch">
									<div class="pc-box box row">
										<div class="col-sm-12 col-md-2 dropship-search-form-by">
											<select name="" id="" class="form-control" v-model="type">
												<option value="product">Nama Produk</option>
												<option value="store">Nama Toko</option>
											</select>
										</div>
										<div
											class="col-sm-12 col-md-4 dropship-search-form-keyword"
										>
											<div class="form-group has-search">
												<i class="material-icons form-control-feedback"
													>search</i
												>
												<input
													type="text"
													class="form-control"
													placeholder="Search"
													v-model="keyword"
												/>
											</div>
										</div>
										<div class="col-sm-12 col-md-4 dropship-search-form-area">
											<!-- <input type="text" class="input form-control" placeholder="Area"> -->
											<multiselect
												v-model="location"
												:loading="isLocationSearching"
												:options="locations"
												track-by="city_name"
												label="city_name_complete"
												:show-labels="false"
												@search-change="onSearchLocationChange"
												@select="onSelectLocation"
												placeholder="Lokasi (opsional)"
											>
												<!-- search empty -->
												<span slot="noResult">Area tidak ditemukan</span>

												<!-- selected -->
												<template slot="singleLabel" slot-scope="props">
													<div class="option__desc">
														<div class="option__title">
															{{ props.option.province_name }},
															{{ props.option.city_name }},
															{{ props.option.subdistrict_name }}
														</div>
													</div>
												</template>
											</multiselect>
										</div>
										<div class="col-sm-12 col-md-2 dropship-search-form-action">
											<button
												class="btn btn-primary px-4 btn-block"
												:class="{ 'is-loading': isFetching }"
												@click="applySearch"
											>
												Apply
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<div class="dropship-categories pb-4">
					<div class="pc-box box p-0">
						<div class="d-flex flex-wrap">
							<div
								class="col-md-3 col-6 dropship-categories-item"
								:class="{
									'active-category': category.slug === $route.query.category,
									'text-primary': category.slug === $route.query.category,
								}"
								v-for="(category, index) in categories"
								:key="index"
							>
								<div
									@click="filterByCategory(category.slug)"
									class="p-3 d-flex align-items-center"
								>
									<img :src="category.image_url" alt="icon" width="36" />
									<span class="ml-2">
										{{ category.name }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Table Loader -->
		<div class="table-fetch-status" v-if="isFetching">
			<div class="is-loading large dark m-auto"></div>
		</div>

		<div class="section section--tight pt-4 dropship-product">
			<div class="container">
				<!-- Featured dropships -->
				<div class="row" v-if="recommendedProducts.length > 0">
					<div class="col-md-12 mb-4">
						<div class="d-flex justify-content-start align-items-center">
							<h4 class="mb-0 mr-2">Rekomendasi Produk</h4>
							<span
								v-if="!isRecommendedLastPage"
								class="text-primary recommended-dropship-more"
								@click="seeMoreRecommendedProduct"
								>Lihat Lainnya
							</span>
						</div>
					</div>

					<div class="col-md-12" v-if="isUserCan('dropship_add')">
						<!-- <div class="dropship-search-form">
							<div class="pc-box box">

							</div>
						</div> -->
						<div class="d-flex mb-3">
							<div>
								<label class="container-relative">
									<input
										type="checkbox"
										v-model="selectAllRecommendedProducts"
										class="dp-checkbox ml-1"
									/>
									<span class="checkmark all"></span>
									<span>Select All</span>
								</label>
							</div>
							<div v-if="selectedRecommendedProducts.length > 0">
								<div class="dropdown">
									<button
										type="button"
										class="btn btn-primary d-flex justify-content-center align-items-center dropdown-toggle btn-block"
										:class="{ 'is-loading': isLoading }"
										data-toggle="dropdown"
										data-display="static"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span class=""> Jual produk terpilih sekarang </span>
									</button>
									<div
										class="dropdown-menu dropdown-menu-left table-action-dropdown"
									>
										<router-link
											v-if="!isOoLoggedIn"
											class="dropdown-item"
											:class="{ 'is-loading': isLoading }"
											to="/settings/connections"
										>
											+ Jual di OrderOnline
										</router-link>
										<button
											v-else
											class="dropdown-item"
											@click="bulkSellProduct"
											:class="{ 'is-loading': isLoading }"
										>
											+ Jual di OrderOnline
										</button>
										<button
											class="dropdown-item disabled"
											v-tooltip="'Coming Soon'"
										>
											+ Jual di Berdu
										</button>
										<button
											class="dropdown-item disabled"
											v-tooltip="'Coming Soon'"
										>
											+ Jual di WooCommerce
										</button>
									</div>
								</div>
							</div>
						</div>
						<progress-bar
							v-if="showRecommendedProgressBar"
							class="mb-2"
							:label="$t('Progress')"
							:value="progress"
							:show-label="true"
						/>
					</div>

					<div
						class="col-lg-2 col-md-4 col-6"
						v-for="(product, index) in recommendedProducts"
						:key="index"
					>
						<div class="dropship-product-item pc-box box p-0">
							<label class="container-cb" v-if="isUserCan('dropship_add')">
								<input
									type="checkbox"
									:disabled="checkProduct(product._id.$oid)"
									:value="product"
									v-model="selectedRecommendedProducts"
									class="dp-checkbox ml-1"
								/>
								<span
									class="checkmark"
									:class="{ disabled: checkProduct(product._id.$oid) }"
								></span>
							</label>
							<div class="dropship-product-item-top cursor-pointer">
								<img
									:src="productImage(product.picture)"
									alt=""
									@click="showDetail(product)"
								/>
							</div>
							<div class="dropship-product-item-detail">
								<div
									class="dropship-product-item-title cursor-pointer"
									@click="showDetail(product)"
								>
									{{ product.name }}
								</div>
								<div @click="showDetail(product)">
									<div class="d-flex justify-content-between">
										<div class="dropship-product-item-price cursor-pointer">
											<span v-tooltip.top-start="'Harga Modal'">{{
												formatMoney(product.price)
											}}</span>
										</div>
										<div
											class="dropship-product-item-stock"
											v-if="product.stock.enabled"
										>
											Stok {{ getStockQuantity(product) }}
										</div>
									</div>
								</div>
								<div class="dropship-product-item-store mt-3 text-capitalize">
									<i class="material-icons">storefront</i>
									{{ product.user.username }}
								</div>
								<div class="dropship-product-item-location">
									<i class="material-icons">room</i>
									{{ product.shipping.origin.city_name }},
									{{ product.shipping.origin.province_name }}
								</div>
							</div>
							<div class="dropship-product-item-action">
								<!--  -->
								<div v-if="isUserCan('dropship_add')">
									<div class="dropdown">
										<button
											type="button"
											class="btn btn-primary d-flex justify-content-center align-items-center dropdown-toggle btn-block"
											:class="{ 'is-loading': isLoading }"
											data-toggle="dropdown"
											data-display="static"
											aria-haspopup="true"
											aria-expanded="false"
										>
											<span class=""> Jual Sekarang </span>
										</button>
										<div
											class="dropdown-menu dropdown-menu-left table-action-dropdown"
										>
											<button
												v-if="checkProduct(product._id.$oid)"
												class="dropdown-item disabled"
											>
												✓ Ditambahkan
											</button>
											<router-link
												v-else-if="!isOoLoggedIn"
												class="dropdown-item"
												:class="{ 'is-loading': isLoading }"
												to="/settings/connections"
											>
												+ Jual di OrderOnline
											</router-link>
											<button
												v-else
												@click="sellProduct(product)"
												class="dropdown-item"
												:class="{ 'is-loading': isLoading }"
											>
												+ Jual di OrderOnline
											</button>
											<button
												class="dropdown-item disabled"
												v-tooltip="'Coming Soon'"
											>
												+ Jual di Berdu
											</button>
											<button
												class="dropdown-item disabled"
												v-tooltip="'Coming Soon'"
											>
												+ Jual di WooCommerce
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12">
						<div
							class="list-empty"
							v-if="products.length === 0 && isFetching === false"
						>
							<i class="material-icons mr-2 va-m">error_outline</i>
							<span class="va-m">{{ $t('No products was found') }}</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 mb-4">
						<h4 class="mb-0">Semua Produk</h4>
					</div>

					<div class="col-md-12" v-if="isUserCan('dropship_add')">
						<div class="d-flex mb-3">
							<div>
								<label class="container-relative">
									<input
										type="checkbox"
										v-model="selectAll"
										class="dp-checkbox ml-1"
									/>
									<span class="checkmark all"></span>
									<span>Select All</span>
								</label>
							</div>
							<div v-if="selectedProducts.length > 0">
								<div class="dropdown">
									<button
										type="button"
										class="btn btn-primary d-flex justify-content-center align-items-center dropdown-toggle btn-block"
										:class="{ 'is-loading': isLoading }"
										data-toggle="dropdown"
										data-display="static"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span class=""> Jual produk terpilih sekarang </span>
									</button>
									<div
										class="dropdown-menu dropdown-menu-left table-action-dropdown"
									>
										<router-link
											v-if="!isOoLoggedIn"
											class="dropdown-item"
											:class="{ 'is-loading': isLoading }"
											to="/settings/connections"
										>
											+ Jual di OrderOnline
										</router-link>
										<button
											v-else
											class="dropdown-item"
											@click="bulkSellProduct"
											:class="{ 'is-loading': isLoading }"
										>
											+ Jual di OrderOnline
										</button>
										<button
											class="dropdown-item disabled"
											v-tooltip="'Coming Soon'"
										>
											+ Jual di Berdu
										</button>
										<button
											class="dropdown-item disabled"
											v-tooltip="'Coming Soon'"
										>
											+ Jual di WooCommerce
										</button>
									</div>
								</div>
							</div>
						</div>
						<progress-bar
							v-if="showProgressBar"
							class="mb-2"
							:label="$t('Progress')"
							:value="progress"
							:show-label="true"
						/>
					</div>

					<div
						class="col-lg-2 col-md-4 col-6"
						v-for="(product, index) in products"
						:key="index"
					>
						<div class="dropship-product-item pc-box box p-0">
							<label class="container-cb" v-if="isUserCan('dropship_add')">
								<input
									type="checkbox"
									:disabled="checkProduct(product._id.$oid)"
									:value="product"
									v-model="selectedProducts"
									class="dp-checkbox ml-1"
								/>
								<span class="checkmark"></span>
							</label>
							<div class="dropship-product-item-top cursor-pointer">
								<img
									:src="productImage(product.picture)"
									alt=""
									@click="showDetail(product)"
								/>
							</div>
							<div class="dropship-product-item-detail">
								<div
									class="dropship-product-item-title cursor-pointer"
									@click="showDetail(product)"
								>
									{{ product.name }}
								</div>
								<div @click="showDetail(product)">
									<div class="d-flex justify-content-between">
										<div class="dropship-product-item-price cursor-pointer">
											<span v-tooltip.top-start="'Harga Modal'">{{
												formatMoney(product.price)
											}}</span>
										</div>
										<div
											class="dropship-product-item-stock"
											v-if="product.stock.enabled"
										>
											Stok {{ getStockQuantity(product) }}
										</div>
									</div>
								</div>
								<div class="dropship-product-item-store mt-3 text-capitalize">
									<i class="material-icons">storefront</i>
									{{ product.user.username }}
								</div>
								<div class="dropship-product-item-location">
									<i class="material-icons">room</i>
									{{ product.shipping.origin.city_name }},
									{{ product.shipping.origin.province_name }}
								</div>
							</div>
							<div class="dropship-product-item-action">
								<div v-if="isUserCan('dropship_add')">
									<div class="dropdown">
										<button
											type="button"
											class="btn btn-primary d-flex justify-content-center align-items-center dropdown-toggle btn-block"
											:class="{ 'is-loading': isLoading }"
											data-toggle="dropdown"
											data-display="static"
											aria-haspopup="true"
											aria-expanded="false"
										>
											<span class=""> Jual Sekarang </span>
										</button>
										<div
											class="dropdown-menu dropdown-menu-left table-action-dropdown"
										>
											<button
												v-if="checkProduct(product._id.$oid)"
												class="dropdown-item disabled"
											>
												✓ Ditambahkan
											</button>
											<router-link
												v-else-if="!isOoLoggedIn"
												class="dropdown-item"
												:class="{ 'is-loading': isLoading }"
												to="/settings/connections"
											>
												+ Jual di OrderOnline
											</router-link>
											<button
												v-else
												@click="sellProduct(product)"
												class="dropdown-item"
												:class="{ 'is-loading': isLoading }"
											>
												+ Jual di OrderOnline
											</button>
											<button
												class="dropdown-item disabled"
												v-tooltip="'Coming Soon'"
											>
												+ Jual di Berdu
											</button>
											<button
												class="dropdown-item disabled"
												v-tooltip="'Coming Soon'"
											>
												+ Jual di WooCommerce
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12">
						<div
							class="list-empty"
							v-if="products.length === 0 && isFetching === false"
						>
							<i class="material-icons mr-2 va-m">error_outline</i>
							<span class="va-m">{{ $t('No products was found') }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Duplicate Product -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowAddProduct = false"
				v-if="isShowAddProduct"
			>
				<div slot="header">
					<h3><i class="material-icons">add</i>{{ $t('dropship.sell') }}</h3>
				</div>
				<div slot="body">
					<form @submit.prevent="sellProduct(selectedProduct)">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group mb-3">
									<label
										><span>Harga Jual</span>
										<i class="material-icons info" v-tooltip="'Harga Modal'"
											>info</i
										></label
									>
									<div class="input-group">
										<div class="input-group-prepend">
											<div class="input-group-text">Rp</div>
										</div>
										<price-display
											v-focus
											class="input form-control"
											min="0"
											v-model="sale_price"
										></price-display>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowAddProduct = false"
					>
						{{ $t('_.cancel') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isLoading }"
						@click="sellProduct(selectedProduct)"
					>
						{{ $t('dropship.sell') }}
					</button>
				</div>
			</modal>
			<product-dropship-detail
				:product="productDetail"
				:price="getFinalPrice(productDetail)"
				@close="isShowDetail = false"
				v-if="isShowDetail"
			/>
		</div>
		<!-- Notifications -->
		<notifications group="dropship" position="bottom right"></notifications>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import dayjs from 'dayjs';
import { dropshipCategories } from '@/lib/statics';
import shippingApi from '@/api/shipping';
import productApi from '@/api/products';
import dropshipApi from '@/api/dropship';
import {
	getAxiosErrorMessage,
	getDropshipFinalPrice,
	getDropshipVariationFinalPrice,
} from '@/lib/helper';
import Modal from '@/components/Modal.vue';
import ProductDropshipDetail from '@/components/ProductDropshipDetail.vue';
import PriceDisplay from '@/components/PriceDisplay.vue';
import ProgressBar from '@/components/ProgressBar.vue';

export default {
	name: 'ProductDropship',
	components: {
		Modal,
		PriceDisplay,
		ProductDropshipDetail,
		ProgressBar,
	},
	data: () => ({
		showProgressBar: false,
		showRecommendedProgressBar: false,
		progress: 0,
		isShowDetail: false,
		sale_price: 0,
		categories: dropshipCategories,
		isShowAddProduct: false,
		isLocationSearching: false,
		location: null,
		locations: [],
		addedDropship: [],
		isLoading: false,
		keyword: '',
		type: 'product',
		category: '',
		cityId: '',
		detailProduct: {},
		selectedProduct: {},
		selectedProducts: [],
		selectedRecommendedProduct: {},
		selectedRecommendedProducts: [],
	}),
	watch: {
		'$route.query': {
			immediate: true,
			handler(val) {
				if (val.keyword) this.keyword = val.keyword;
				if (val.category) this.category = val.category;
				if (val.type) this.type = val.type;
				if (val.city_id) {
					this.cityId = val.city_id;
					if (this.location === null) {
						this.fetchCompleteDistrict({ cityId: val.city_id });
					}
				}
			},
		},
		user() {
			this.checkCapabilities();
		},
	},
	created() {
		this.init();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	computed: {
		...mapGetters({
			user: 'user',
			products: 'dropshipProducts/products',
			recommendedProducts: 'recommendedProducts/products',
			isFetching: 'dropshipProducts/isFetching',
			isAll: 'dropshipProducts/isAll',
			isFetchingRecommendedProduct: 'recommendedProducts/isFetching',
			isAllRecommendedProduct: 'recommendedProducts/isAll',
			page: 'dropshipProducts/page',
			recommendedPage: 'recommendedProducts/page',
			pageInfo: 'dropshipProducts/pageInfo',
			recommendedPageInfo: 'recommendedProducts/pageInfo',
			isOoLoggedIn: 'isOoLoggedIn',
			isUserCan: 'isUserCan',
		}),
		selectAll: {
			get() {
				return this.products
					? this.selectedProducts.length === this.products.length
					: false;
			},
			set(value) {
				const selected = [];
				console.log(value);
				if (value) {
					this.products.forEach((product) => {
						if (!this.checkProduct(product._id.$oid)) {
							selected.push(product);
						}
					});
				}
				this.selectedProducts = selected;
				this.showProgressBar = false;
			},
		},
		selectAllRecommendedProducts: {
			get() {
				return this.products
					? this.selectedRecommendedProducts.length
							=== this.recommendedProducts.length
					: false;
			},
			set(value) {
				const selected = [];
				console.log(value);
				if (value) {
					this.recommendedProducts.forEach((product) => {
						if (!this.checkProduct(product._id.$oid)) {
							selected.push(product);
						}
					});
				}
				this.selectedRecommendedProducts = selected;
				this.showProgressBar = false;
			},
		},
		isLastPage() {
			if (this.pageInfo && this.pageInfo.last_page >= this.page) {
				return false;
			}
			return true;
		},
		isRecommendedLastPage() {
			if (
				this.recommendedPageInfo
				&& this.recommendedPageInfo.last_page >= this.recommendedPage
			) {
				return false;
			}
			return true;
		},
	},
	methods: {
		...mapActions({
			getProducts: 'dropshipProducts/getProducts',
			resetProducts: 'dropshipProducts/resetProducts',
			getRecommendedProducts: 'recommendedProducts/getProducts',
			resetRecommendedProducts: 'recommendedProducts/resetProducts',
		}),
		init() {
			// this.checkCapabilities();
			this.fetchProducts(true);
			this.fetchRecommendedProducts(true);
			this.fetchAddedDropshipProduct();
			if (this.user) {
				this.checkCapabilities();
			}
		},
		checkCapabilities() {
			if (!this.isUserCan('dropship_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const variationPrice = product.variations.prices.reduce(
				(prevQty, variation) => {
					const variationQuantity = variation.stock
						? variation.stock.quantity
						: 0;
					const totalQuantity = prevQty + variationQuantity;
					return totalQuantity;
				},
				0,
			);
			const quantity = isSimple ? product.stock.quantity : variationPrice;
			return quantity;
		},
		showDetail(product) {
			this.productDetail = product;
			this.isShowDetail = true;
		},
		onChangeSelectAll() {
			if (this.selectAll) {
				console.log(this.selectAll);
			}
		},
		seeMoreRecommendedProduct() {
			if (
				!this.isFetchingRecommendedProduct
				&& !this.isAllRecommendedProduct
				&& !this.isRecommendedLastPage
			) {
				this.fetchRecommendedProducts(false);
			}
		},
		openAddProductModal(product) {
			this.selectedProduct = product;
			this.sale_price = this.getFinalPrice(product, false);
			this.isShowAddProduct = true;
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll && !this.isLastPage) {
					this.fetchProducts(false);
				}
			}
		},
		productImage(url) {
			const image = url || 'https://place-hold.it/200x200';
			return image;
		},

		sellProduct(product, bulk = false) {
			// sell product oo
			this.sellProductOO(product, bulk);
			// duplicate LP
			this.duplicateFunnel(product);
		},

		bulkSellProduct() {
			this.isLoading = true;
			this.showProgressBar = true;
			const total = this.selectedProducts.length;
			let current = 0;
			this.selectedProducts.forEach((product) => {
				current++;
				this.progress = (current / total) * 100;
				this.sellProduct(product, true);
			});
			this.isLoading = false;
		},
		bulkSellRecommendedProduct() {
			this.isLoading = true;
			this.showRecommendedProgressBar = true;
			const total = this.selectedRecommendedProducts.length;
			let current = 0;
			this.selectedRecommendedProducts.forEach((product) => {
				current++;
				this.progress = (current / total) * 100;
				this.sellProduct(product, true);
			});
			this.isLoading = false;
		},

		duplicateFunnel(product) {
			const pages = product.pages ? product.pages : [];
			if (pages.length > 0) {
				const pageIds = pages.map(page => page.url.replace('https://app.orderonline.id/funnels/sharer/', ''));

				const params = {
					ids: JSON.stringify(pageIds),
					all_pages: true,
				};
				console.log(params);
				const callback = () => {
					this.isLoading = false;
					this.isShowAddProduct = false;
					console.log('duplicate success');
				};
				const errorCallback = (e) => {
					this.isLoading = false;
					const message = getAxiosErrorMessage(e);
					if (message || message !== '') {
						this.$notify({
							group: 'dropship',
							title:
								'Error duplicate funnel page into your orderonline account',
							text: message,
							type: 'error',
						});
					}
					console.log('message: ', e);
				};
				dropshipApi.duplicateFunnel(params, callback, errorCallback);
			}
		},

		sellProductOO(product, bulk = false) {
			this.isLoading = true;
			product.dropship.original_price = product.price;
			const params = {
				name: product.name,
				autoresponders: JSON.stringify(product.autoresponders),
				bump: JSON.stringify(product.bump),
				category: JSON.stringify(product.category),
				code: product.code,
				collections: JSON.stringify(product.collections),
				description: product.description,
				form: JSON.stringify(product.form),
				pictures: JSON.stringify(product.pictures),
				slug: product.slug,
				type: product.type,
				price: this.getFinalPrice(product, false),
				sale_price: JSON.stringify(product.sale_price),
				weight: product.weight,
				shipping: JSON.stringify(product.shipping),
				dropship: JSON.stringify(product.dropship),
				variations: JSON.stringify(getDropshipVariationFinalPrice(product)),
				is_deleted: product.is_deleted,
				is_public: product.is_public,
				max_quantity: JSON.stringify(product.max_quantity),
				notifications: JSON.stringify(product.notifications),
				order_distribution: JSON.stringify(product.order_distribution),
				payment_channels: JSON.stringify(product.payment_channels),
				payment_channels_descriptions: JSON.stringify(
					product.payment_channels_descriptions,
				),
				payment_methods_descriptions: JSON.stringify(
					product.payment_methods_descriptions,
				),
				payments: JSON.stringify(product.payments),
				status: product.status,
				stock: JSON.stringify(product.stock),
				unique_code_price: JSON.stringify(product.unique_code_price),
				wholesale: JSON.stringify(product.wholesale),
				facebook_custom_audiences: JSON.stringify(
					product.facebook_custom_audiences,
				),
				source_id: product._id.$oid,
				source_type: 'inventro',
				source_user_id: product.user._id.$oid,
				pages: JSON.stringify(product.pages),
				videos: JSON.stringify(product.videos),
				commission_percentage: product.commission_percentage,
			};
			if (product.outsource_commission) {
				params.outsource_commission = JSON.stringify(product.outsource_commission);
			}
			const callback = (res) => {
				const OoProduct = res.data;
				this.addedDropship.push({ source_id: product._id.$oid });
				const index = this.selectedProducts.findIndex(
					el => el.product._id.$oid === product._id.$oid,
				);
				if (index !== -1) {
					this.selectedProducts.splice(index, 1);
				}
				this.isLoading = false;
				this.isShowAddProduct = false;
				this.addProduct(product._id.$oid, {
					price: this.getFinalPrice(product, false),
					source_type: 'orderonline',
					reference_id: OoProduct._id,
				});
				if (!bulk) {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: `Berhasil menambah produk ${product.name}`,
						type: 'success',
					});
				}
			};
			const errorCallback = (e) => {
				this.isLoading = false;
				const message = getAxiosErrorMessage(e);
				if (message || message !== '') {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: message,
						type: 'error',
					});
				}
				console.log('message: ', e);
			};
			console.log(params);
			dropshipApi.addDropshipProduct(
				product._id.$oid,
				params,
				callback,
				errorCallback,
			);
		},
		async addProduct(id, params) {
			const response = await productApi.addDropshipProduct(id, params);
			console.log(response.data);
		},
		checkProduct(id) {
			return this.addedDropship.find(myid => myid.source_id === id);
		},
		getFinalPrice(product, format = true) {
			const price = getDropshipFinalPrice(product);
			// const price = getFinalPrice(product);
			return format ? this.formatMoney(price) : price;
		},
		fetchCompleteDistrict({ keyword, cityId }) {
			if (keyword !== '' && cityId !== '') {
				this.locations = [];

				this.isLocationSearching = true;
				const params = {
					get_complete_data: 1,
					page: 1,
				};
				if (keyword !== '') {
					params.keyword = keyword;
				}
				if (cityId !== '') {
					params.city_id = cityId;
				}
				const callback = (response) => {
					const locations = response.data;
					this.locations = locations;
					if (locations.length === 1) {
						this.location = locations[0];
					}
					this.isLocationSearching = false;
				};
				const errorCallback = (e) => {
					this.isLocationSearching = false;
					const message = getAxiosErrorMessage(e);
					console.log('message: ', message);
				};
				shippingApi.getCompleteCities(params, callback, errorCallback);
			}
		},
		fetchAddedDropshipProduct() {
			// this.isLocationSearching = true;
			const callback = (response) => {
				const products = response.data;
				this.addedDropship = products;
				// this.isLocationSearching = false;
			};
			const errorCallback = (e) => {
				// this.isLocationSearching = false;
				const message = getAxiosErrorMessage(e);
				console.log('message: ', message);
			};
			dropshipApi.getAddedDropshipProducts(callback, errorCallback);
		},
		fetchProducts(reset = false) {
			if (reset) {
				this.resetProducts();
			}
			const params = this.generateParams();
			this.getProducts(params);
		},
		fetchRecommendedProducts(reset = false) {
			if (reset) {
				this.resetRecommendedProducts();
			}
			const params = this.generateRecommendedParams();
			this.getRecommendedProducts(params);
		},
		generateParams() {
			const params = {
				page: this.page,
			};
			if (this.keyword !== '') {
				params.keyword = this.keyword;
			}
			if (this.category !== '') {
				params.category = this.category;
			}
			if (this.location !== '' && this.location !== null) {
				params.city_id = this.location.city_id;
			}
			if (this.cityId !== '' && this.cityId !== null) {
				params.city_id = this.cityId;
			}
			if (this.type !== '') {
				params.type = this.type;
			}

			this.$router.push({ query: params }).catch(() => {});

			return params;
		},
		generateRecommendedParams() {
			const params = {
				page: this.recommendedPage,
				recommendation: true,
			};
			if (this.keyword !== '') {
				params.keyword = this.keyword;
			}
			if (this.category !== '') {
				params.category = this.category;
			}
			if (this.location !== '' && this.location !== null) {
				params.city_id = this.location.city_id;
			}
			if (this.cityId !== '' && this.cityId !== null) {
				params.city_id = this.cityId;
			}
			if (this.type !== '') {
				params.type = this.type;
			}

			return params;
		},
		applySearch() {
			this.fetchProducts(true);
			this.fetchRecommendedProducts(true);
		},
		filterByCategory(category) {
			if (this.category === category) {
				this.category = '';
			} else {
				this.category = category;
			}
			this.fetchProducts(true);
			this.fetchRecommendedProducts(true);
		},
		onSearchLocationChange(keyword) {
			this.ooDelay(() => {
				this.fetchCompleteDistrict({ keyword });
			}, 500);
		},
		onSelectLocation() {},
		fetchOoToken() {
			this.getOoToken();
		},
	},
};
</script>
